/** The browser tab's title: the platform's name in both products, on every page, in a conversation too (15a). */
export const TAB_TITLE = 'Oppy';
